import { connect } from 'react-redux'
import get from 'lodash/get'

import { Ad } from '../components/Ad'
import { pushAd } from '../reducers/ads'

const mapStateToProps = (state, ownProps) => ({
  adId: ownProps.adId,
  className: ownProps.className,
  minScreenSize: ownProps.minScreenSize,
  isSticky: ownProps.isSticky,
  marginBottom: ownProps.marginBottom,
  pclnBootstrapData: get(state, 'pclnBootstrapData', {}),
  listingsLastUpdateTime: get(state, 'listings.lastUpdateTime'),

  // Mobiles Props
  gaIndex: ownProps.gaIndex,
  departingFrom: ownProps.departingFrom,
  returningFrom: ownProps.returningFrom,
  searchReferralId: ownProps.searchReferralId,
  inlineAds: ownProps.inlineAds,
  fitWidth: ownProps.fitWidth,
})

const mapDispatchToProps = (dispatch) => ({
  pushAd: (ad) => {
    dispatch(pushAd(ad))
  },
})

const AdContainer = connect(mapStateToProps, mapDispatchToProps)(Ad)

export { AdContainer }
